import { EntUnitMeasurement } from "../handBooks/unitMeasurement";
import { EntProductType } from "./grossProductCollection";
import { EntCitizenship } from "../citizenship/citizenship";

export class EntLivestockTradeActivity {
  id: number|null = null;
  year: number|null = null;
  citizenship?: EntCitizenship|null = null;
  productType?: EntProductType|null = null;
  operationType?: string|null = null;
  hsCode?: string|null = null;
  unitMeasurement?: EntUnitMeasurement|null = null;
  amount?: number|null = null;

  citizenshipId?: number|null = null;
  productTypeId?: number|null = null;
  unitMeasurementId?: number|null = null;
}